var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-6"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('h4',{staticClass:"m-t-10"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }